import styled from 'styled-components';

import { Display } from '@rover/kibble/core';
import { Props as DisplayProps } from '@rover/kibble/core/Display';
import { MQ, Spacing } from '@rover/kibble/styles';
import VerticalLayout from '@rover/react-lib/src/components/layouts/VerticalLayout';
import LinkOrganizer from '@rover/react-lib/src/components/lists/LinkOrganizer';
import { Anchor } from '@rover/types/src/Anchor';

const NUM_COLUMNS = 6;

export type Props = {
  citiesOrNeighborhoods: Anchor[];
  children?: React.ReactNode;
};

const StyledLayout = styled(VerticalLayout)`
  align-items: normal;
  margin-top: ${Spacing.XL.toString()};
  ${MQ.XS_DOWN.toString()} {
    margin-top: ${Spacing.L.toString()};
  }
`;

const StyledLinkOrganizer = styled(LinkOrganizer)`
  ${MQ.XS_DOWN.toString()} {
    padding-left: 0;
  }
`;

const CitiesAndNeighborhoods = ({
  citiesOrNeighborhoods,
  children,
  ...props
}: Props): JSX.Element => {
  return (
    <StyledLayout {...props}>
      {children}
      <StyledLinkOrganizer
        links={citiesOrNeighborhoods}
        columnGap={Spacing.L.toString()}
        columns={[NUM_COLUMNS / 3, NUM_COLUMNS / 2, NUM_COLUMNS]}
      />
    </StyledLayout>
  );
};

CitiesAndNeighborhoods.Display = ({ children, ...props }: DisplayProps): JSX.Element => {
  return (
    <Display as="h3" size="500" responsive={false} textAlign="center" {...props}>
      {children}
    </Display>
  );
};

export default CitiesAndNeighborhoods;
